import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: "0 3%",
    border: "0",
  },

  formControl: {
    marginLeft: 10,
    marginRight: 10,
    border: "2px solid #e45826",
    borderRadius: 50,
    width: 160,
    height: 35,
    [theme.breakpoints.down("xs")]: {
      marginTop: "25px",
      marginLeft: 10,
      marginBottom: "25px",
      width: 255,
    },
  },
  selected: {
    height: "48px",
    borderRadius: "20px",
    width: 140,
    marginLeft: 10,
    [theme.breakpoints.down("xs")]: {
      width: 235,
    },
  },
  formControlDrop: {
    margin: theme.spacing(1),
    minWidth: 120,
    border: 0,
  },

  selectEmpty: {
    marginTop: theme.spacing(2),
  },

  button: {
    borderRadius: "20px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    backgroundColor: "#e45826",
    color: "#fff",
    width: "150px",
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "25px",
      width: 260,
    },
  },
  select: {
    height: "40px",
    width: "200px",
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      width: 260,
      paddingLeft: theme.spacing(0),
      marginTop: theme.spacing(1.5),
    },
  },

  input: {
    [theme.breakpoints.down("xs")]: {
      borderRadius: 50,
      border: "1px solid #ff5903",
      padding: "6px 26px 6px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      fontFamily: "Gilroy-Light, serif",
      "&:focus": {
        borderRadius: 50,
        borderColor: "#ff5903",
      },
    },
  },
}));

export const BootstrapInput = withStyles((theme) => ({}))(InputBase);
